
export default function routes($stateProvider) {
	$stateProvider
		.state('emailTemplatesPage', {
			url: '/templates',
			template: require('./emailTemplates.html'),
			resolve: {
				loggedIn: ['User', function (User) {
					return User.requireLogin();
				}],
				emailTemplates: ['EmailTemplate', function (EmailTemplate) {
					return EmailTemplate.all();
				}],
				zones: ['Zone', function (Zone) {
					return Zone.all();
				}]
			},
			controller: 'EmailTemplatesController',
			controllerAs: 'emailTemplates'
		});
}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/emailTemplates/emailTemplates.routes.js